import React from 'react';
import { Linkedin, Mail, MessageCircle } from 'lucide-react';
interface FooterProps {
  onTermsClick: () => void;
  onContactClick: () => void;
}
export const Footer = ({
  onTermsClick,
  onContactClick
}: FooterProps) => {
  return <footer className="bg-gray-50 text-gray-600" data-id="element-779">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-780">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-781">
          <div data-id="element-782">
            <h3 className="text-[#6366f1] text-lg font-semibold mb-4" data-id="element-783">
              usegigi.ai
            </h3>
            <p className="text-gray-500" data-id="element-784">
              Your personal outreach assistant for modern businesses.
            </p>
          </div>
          <div data-id="element-785">
            <h4 className="text-gray-900 font-semibold mb-4" data-id="element-786">Legal</h4>
            <ul className="space-y-2" data-id="element-787">
              <li data-id="element-788">
                <button onClick={onTermsClick} className="hover:text-[#6366f1] transition-colors" data-id="element-789">
                  Terms of Service
                </button>
              </li>
              <li data-id="element-790">
                <a href="#" className="hover:text-[#6366f1] transition-colors" data-id="element-791">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-792">
                <a href="#" className="hover:text-[#6366f1] transition-colors" data-id="element-793">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-794">
            <h4 className="text-gray-900 font-semibold mb-4" data-id="element-795">Support</h4>
            <ul className="space-y-2" data-id="element-796">
              <li data-id="element-797">
                <a href="#" className="hover:text-[#6366f1] transition-colors" data-id="element-798">
                  Help Center
                </a>
              </li>
              <li data-id="element-799">
                <button onClick={onContactClick} className="hover:text-[#6366f1] transition-colors" data-id="element-800">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>
          <div data-id="element-801">
            <h4 className="text-gray-900 font-semibold mb-4" data-id="element-802">Connect</h4>
            <div className="flex space-x-4" data-id="element-803">
              <a href="https://www.linkedin.com/in/irina-lam/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#6366f1] transition-colors" aria-label="LinkedIn Profile" data-id="element-804">
                <Linkedin size={20} data-id="element-805" />
              </a>
              <a href="mailto:ready@set-sell.com" className="text-gray-400 hover:text-[#6366f1] transition-colors" aria-label="Email Us" data-id="element-806">
                <Mail size={20} data-id="element-807" />
              </a>
              <a href="https://wa.me/40736718154" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#6366f1] transition-colors" aria-label="WhatsApp" data-id="element-808">
                <MessageCircle size={20} data-id="element-809" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-12 pt-8 text-sm text-center text-gray-500" data-id="element-810">
          © 2025 usegigi.ai. All rights reserved.
        </div>
      </div>
    </footer>;
};